import React, { useState } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import ObjectivesFormNew from '../components/ObjectivesFormNew';
import { ArrowLeft, ArrowRight, AlertCircle } from 'lucide-react';
import { toast } from 'sonner';

export function StepObjectives({ objectives, onObjectivesChange, onNext, onBack }) {
  const [showErrors, setShowErrors] = useState(false);

  // Validar que haya al menos 1 objetivo con descripción
  const validateObjectives = () => {
    // Handle legacy format
    if (objectives && (objectives['3m'] || objectives['6m'] || objectives['9m'])) {
      const allObjs = [
        ...(objectives['3m'] || []),
        ...(objectives['6m'] || []),
        ...(objectives['9m'] || [])
      ];
      return allObjs.some(obj => obj.description && obj.description.trim().length > 0);
    }
    
    // Handle array format
    if (Array.isArray(objectives)) {
      return objectives.some(obj => obj.description && obj.description.trim().length > 0);
    }
    
    return false;
  };

  const handleNext = () => {
    if (!validateObjectives()) {
      setShowErrors(true);
      toast.error('Necesitás completar al menos 1 objetivo');
      return;
    }
    
    setShowErrors(false);
    onNext();
  };

  return (
    <div className="max-w-3xl mx-auto space-y-6">
      <Card>
        <CardHeader className="text-center">
          <CardTitle className="text-2xl">Tus Objetivos</CardTitle>
          <CardDescription>
            Define tus metas y las acciones concretas que tomarás para alcanzarlas.
            Podés agregar tantos objetivos como necesites, cada uno con su plazo (3, 6 o 9 meses).
          </CardDescription>
          <p className="text-xs text-muted-foreground mt-2">
            Es obligatorio definir al menos 1 objetivo con descripción.
          </p>
        </CardHeader>
        <CardContent>
          <ObjectivesFormNew
            objectives={objectives}
            onChange={onObjectivesChange}
            showErrors={showErrors}
          />
        </CardContent>
      </Card>

      <div className="flex justify-between gap-4">
        <Button variant="outline" onClick={onBack} data-testid="wizard-back-button">
          <ArrowLeft className="w-4 h-4 mr-2" />
          Atrás
        </Button>
        <Button onClick={handleNext} className="flex-1" data-testid="wizard-next-button">
          Siguiente
          <ArrowRight className="w-4 h-4 ml-2" />
        </Button>
      </div>
    </div>
  );
}

export default StepObjectives;
